import { Group, Stack } from '@mantine/core';
import type { FC } from 'react';

import { PhoneNumberInput } from '../../components/reactHookFormMantine/PhoneInput/PhoneInput.tsx';
import { TextInput } from '../../components/reactHookFormMantine/TextInput';
import { useI18n } from '../../hooks/useI18n.ts';
import type { FormInputsContent } from '../FormInputsContent.ts';
import type { FormUserAndPromoter } from './schema';

export const UserAndPromoter: FC<FormInputsContent<FormUserAndPromoter>> = ({ useFormValue: { control } }) => {
  const { t } = useI18n();

  return (
    <Stack gap="xs" pos="relative">
      <Group grow align="flex-start" gap="xs">
        <TextInput
          autoComplete="firstName"
          control={control}
          label={t('user-and-promoter_label--first-name') ?? 'First name'}
          name="firstName"
          type="input"
        />
        <TextInput
          autoComplete="lastName"
          control={control}
          label={t('user-and-promoter_label--last-name') ?? 'Last name'}
          name="lastName"
          type="input"
        />
      </Group>
      <TextInput
        autoComplete="organisationName"
        control={control}
        label={t('user-and-promoter_label--organisation-name') ?? 'Organisation name'}
        name="organisationName"
        type="input"
      />
      <PhoneNumberInput
        autoComplete="tel"
        control={control}
        label={t('user-and-promoter_label--phone-number') ?? 'Phone number'}
        name="phoneNumber"
      />
    </Stack>
  );
};
